import React from 'react';
import {connect} from 'react-redux';
import Staff from './staff';
import AddStaff from './add-staff';
import {addStaff, getStaffMember, resendInvitation} from '../../actions/staff';

const StaffList = (props) => {
  const onAddStaffClicked = () => {
    props.openModal();
    props.dispatch(addStaff(props.outlet))
      .then(() => {
        props.dispatch({
          type: 'SHOW_EDIT_STAFF',
          payLoad: {id: -1}
        });
      });
  };

  const onResendClicked = (link) => {
    props.dispatch(resendInvitation(link));
  };

  const onEditStaffClicked = (link, row, status) => {
    props.openModal();
    props.dispatch(addStaff());
    props.dispatch(getStaffMember(link, row, status));
  };

  // eslint-disable-next-line react/jsx-one-expression-per-line
  let staffItems = [<h1 key={0}>Loading...</h1>];

  if (props.fetched) {
    staffItems = [];

    props.staff.forEach((staff) => {
      staffItems.push(<Staff
        key={staff.id}
        onEditStaffClicked={onEditStaffClicked}
        onResendClicked={onResendClicked}
        open={props.staff_member_id === staff.id}
        row={staffItems.length - 1}
        staff={staff}
      />);
    });

    staffItems.push(<AddStaff
      key="-1"
      onAddStaffClicked={onAddStaffClicked}
      open={props.staff_member_id === -1}
    />);
  }

  return (
    <div className="my-staff-cards-container">
      {staffItems.length > 0 && staffItems.map((item, index) => (
        <div key={index}>{item}</div>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  editStaffVisible: state.staff.editStaffVisible,
  staff_member_id: state.staff.staff_member_id,
  staff_member_row: state.staff.staff_member_row
});

export default connect(mapStateToProps)(StaffList);



// WEBPACK FOOTER //
// ./src/components/my-staff/staff-list.jsx